import React from "react";
import DataFilterVisualization from "./index";

 const productAnalysis = () => {
  return <DataFilterVisualization />;
};
export default productAnalysis;